var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1434_9141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.20005 1.75C8.60005 1.75 10.6 3.75 10.6 6.15C10.6 8.55 8.60005 10.55 6.20005 10.55C3.80005 10.55 1.80005 8.55 1.80005 6.15C1.80005 3.75 3.80005 1.75 6.20005 1.75ZM6.20005 0.25C2.90005 0.25 0.300049 2.85 0.300049 6.15C0.300049 9.45 2.90005 12.05 6.20005 12.05C9.50005 12.05 12.1 9.45 12.1 6.15C12.1 2.85 9.50005 0.25 6.20005 0.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7001 13.7499L9.6001 9.6499",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1434_9141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4,
    height: 13.5,
    fill: "white",
    transform: "translate(0.300049 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSearch);
export default __webpack_public_path__ + "static/media/whiteSearch.d3b56136faf4cdf73d66c0647ca8c70e.svg";
export { ForwardRef as ReactComponent };